import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { DirLeadStatusType } from '@econtractor/types';
import { tDirName } from 'utils/helpers/i18n/tDirName';
import LeadDashboardChart from './LeadDashboardChart';

interface LeadDashboardCardProps {
    status: DirLeadStatusType;
    count: number | null;
    total: number | null;
}

const sharePercent = (count: number | null, total: number | null): number => {
    if (count === null || total === null || total <= 0 || count <= 0) return 0;
    return Math.min((count / total) * 100, 100);
};

const shareLabel = (count: number | null, total: number | null): string => {
    if (count === null || total === null) return '–';
    if (total <= 0 || count <= 0) return '0%';
    const pct = Math.round((count / total) * 100);
    return pct === 0 ? '<1%' : `${pct}%`;
};

const LeadDashboardCard = ({ status, count, total }: LeadDashboardCardProps) => {
    const { t } = useTranslation(['Leads']);
    const statusStyle = status.statusJson?.statusStyle || 'danger';
    const label = tDirName(t, status.i18nKey, status.statusName) || t(`status.${status.ID}`);
    const percent = sharePercent(count, total);
    const percentLabel = shareLabel(count, total);

    return (
        <div className={`leads-dashboard__card is-${statusStyle}`}>
            <div className="leads-dashboard__row">
                <div className="leads-dashboard__chart">
                    <LeadDashboardChart percent={percent} />
                    <span className="leads-dashboard__chart-pct">{percentLabel}</span>
                </div>
                <div className="leads-dashboard__count">
                    {count === null ? '–' : count}
                </div>
            </div>
            <Badge className="fs-10 text-truncate leads-dashboard__badge" bg={statusStyle} title={label}>
                {label}
            </Badge>
        </div>
    );
};

export default LeadDashboardCard;
